import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function PortalRegisterRedirect() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get('token');
    if (token) {
      navigate(`/register/${token}`, { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate, params]);

  return null;
}
